

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueValidator from 'vue-validator'
import axios from './api/http'
import App from './App'
import router from './router'
import ElementUI from 'element-ui' ;
import { installButtonDebounce } from './utils/button-debounce'

import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css'

import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css'

import 'bootstrap-vue/dist/bootstrap-vue.css'


//import Mock from './mock'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$store=store
Vue.use(VueValidator)
Vue.use(ElementUI)
Vue.use(BootstrapVue)
installButtonDebounce()




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})
// 百度统计
// router.afterEach( ( to, from, next ) => {
//     setTimeout(()=>{
//             var _hmt = _hmt || [];
//             (function() {
//                 //每次执行前，先移除上次插入的代码
//                 document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
//                 var hm = document.createElement("script");
//                 hm.src = "https://hm.baidu.com/hm.js?959a3ebdb22d05a964379f0f412e3d64";
//                 hm.id = "baidu_tj"
//                 var s = document.getElementsByTagName("script")[0];
//                 s.parentNode.insertBefore(hm, s);
//             })();
//     },0);
// } );



// WEBPACK FOOTER //
// ./src/main.js